// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_kw-6";
export var emphasizeQuantity = "_kw-3";
export var flatBottomCorners = "_kw-5";
export var productImage = "_kw-0";
export var quantityContainer = "_kw-2";
export var tooltip = "_kw-1";
export var wrapAndEllipsesOverflow = "_kw-4";